import React from 'react';

const Authorline = ({ id, displayName, profilPicture, creationDate }) => {
    return (
        <tr className='flex justify-between w-full text-left py-2 border-b-2 text-white'>
            <td hidden={true}>{`${id}`}</td>
            <td className='w-1/6'>{displayName}</td>
            <td className='w-2/6'>
                <div className="rounded-full w-10 h-10 border-white border bg-cover bg-center"
                    style={{ backgroundImage: `url(${profilPicture})` }} />
            </td>
            <td className='w-1/6'>{creationDate}</td>
        </tr>)
}

export default Authorline